module.exports = __webpack_public_path__ + "static/media/MaterialIcons-Regular.a37b0c01.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons/iconfont/MaterialIcons-Regular.ttf
// module id = 400
// module chunks = 0